import React, { PureComponent } from 'react';
import { autobind } from 'core-decorators';
import types from 'prop-types';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import './react-sliding-pane.css';
import { createGlobalStyle } from 'styled-components';
import Form from '../forms/Form';
import CloseIcon from '@rexlabs/icons/large/close.svg';
import SlideoutContainer from './slideout-container';

const GlobalStyle = createGlobalStyle`

    .button {
        cursor: pointer;
    }

    .button svg {
        width: 32px;
        height: 32px;
    }

    .slideout-container {
        height: 100%;
    }

    .slide-pane__header {
        background-color: ${(props) =>
          props.headerBackgroundColor ?? props.backgroundColor} !important;
    }

    .slide-pane__content {
        background-color: ${(props) => props.backgroundColor} !important;
    }

    .slide-pane__close {
        color: ${(props) => props.menuFontColor} !important;
    }

    .slide-pane__overlay {
     z-index: 999;
    }

    .slide-pane__close {
        margin-top: 24px;
        margin-right: 24px;
        padding: 5px;
        opacity: 0.7;
        cursor: pointer;
        position: absolute;
        right: 0;
    }


    @media(max-width: 768px) {
        .pane {
            width: 100% !important;
        }
    }

`;

@autobind
class Slideout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isPaneOpen: false,
      isPaneOpenLeft: false,
      form: props.form,
      formLocation: props.formLocation,
      formId: props.formId,
      content: props.content,
      backgroundColor: props.backgroundColor,
      headerBackgroundColor: props.headerBackgroundColor,
      menuFontColor: props.menuFontColor
    };
  }

  handleClick = (event) => {
    const target = event.target;

    // If we have an offcanvas form, open the form instead of navigating the link
    // if (
    //   target.tagName === 'A' &&
    //   target.pathname.replaceAll('/', '') === 'offcanvas_form'
    // ) {
    //   const urlParams = this.parseQuery(target.search);
    //   const formLocation = urlParams?.location;
    //   const formId = urlParams?.id;
    //   const formBackgroundColor = 'white';
    //   const formHeaderBackgroundColor = '#f3f3f3';

    //   event.preventDefault();
    //   event.stopPropagation();

    //   this.setState({
    //     content: null,
    //     formLocation: formLocation,
    //     formId: formId,
    //     isPaneOpenLeft: true,
    //     backgroundColor: formBackgroundColor,
    //     headerBackgroundColor: formHeaderBackgroundColor
    //   });
    //   return false;
    // }
  };

  parseQuery(queryString) {
    const query = {};
    const pairs = (queryString[0] === '?'
      ? queryString.substr(1)
      : queryString
    ).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  componentDidMount() {
    Modal.setAppElement(this.el);

    // Listen to clicks for links that open slideout
    document.addEventListener('click', this.handleClick);

    // Allow slideout to be opened from anywhere
    document.openSlideout = ({
      formLocation,
      formId,
      formExtraFields,
      resourceId,
      resourceType,
      content,
      backgroundColor,
      headerBackgroundColor
    }) => {
      this.setState({
        content,
        formLocation,
        formExtraFields,
        formId,
        isPaneOpenLeft: true,
        resourceId,
        resourceType,
        backgroundColor,
        headerBackgroundColor
      });
    };
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  onClose() {
    this.setState({ isPaneOpenLeft: false });
  }

  render() {
    const { paneDirection, websiteId } = this.props;

    const {
      form,
      formLocation,
      resourceId,
      resourceType,
      formId,
      formExtraFields,
      content,
      backgroundColor,
      headerBackgroundColor,
      menuFontColor
    } = this.state;

    return (
      <div ref={(ref) => (this.el = ref)} className={'slideout-container'}>
        <GlobalStyle
          headerBackgroundColor={headerBackgroundColor}
          backgroundColor={backgroundColor}
          menuFontColor={menuFontColor}
        />

        <SlidingPane
          className={'pane'}
          closeIcon={<CloseIcon />}
          isOpen={this.state.isPaneOpenLeft}
          from={paneDirection}
          width='400px'
          onRequestClose={this.onClose}
        >
          {content && <SlideoutContainer>{content}</SlideoutContainer>}

          {!content && (form || formId || formLocation) && (
            <Form
              slideout
              key={formLocation || formId}
              form={form}
              websiteId={websiteId}
              formLocation={formLocation}
              formId={formId}
              resourceId={resourceId}
              resourceType={resourceType}
              onClose={this.onClose}
              formExtraFields={formExtraFields}
            />
          )}
        </SlidingPane>
      </div>
    );
  }
}

Slideout.propTypes = {
  label: types.string,
  headerBackgroundColor: types.string,
  backgroundColor: types.string,
  fontColor: types.string,
  paneDirection: types.string,
  form: types.object,
  websiteId: types.string,
  content: types.string,
  formLocation: types.string,
  menu: types.object,
  menuFontColor: types.string
};

Slideout.defaultProps = {
  backgroundColor: '#000',
  fontColor: '#fff',
  paneDirection: 'left'
};

export default Slideout;
window.__Components.Slideout = Slideout;
